import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { TEMPLATE_LAYOUT } from "../../constants/dashboard";
import { openCansvasSizeModal } from "../../store/common/profileModalSlice";
import { getFromLocal } from "../../utils/localStorage";

const CreateVideoCard = () => {
  const dispatch = useDispatch();
  const { activeLayout } = useSelector((state) => state.templates);
  const videoLength = getFromLocal("videos");
  const disabled = videoLength === 0;
  return (
    <div
      className={`flex cursor-pointer flex-col gap-2 items-center justify-center mt-2 ${
        disabled ? "cursor-not-allowed" : ""
      } ${
        activeLayout === TEMPLATE_LAYOUT.VERTICAL
          ? "h-[180px] w-[117px] aspect-[117/180]"
          : "w-[270px] h-[157px] aspect-[275/160]"
      } inline-block border-dashed border-2  rounded-lg bg-white`}
      onClick={() => !disabled && dispatch(openCansvasSizeModal())}
    >
      <img
        src={"/tool/dashboard/static/images/create-video-grey.png"}
        alt={"Create Video"}
        className="w-12 h-12"
      />
      <p className="us text-sm text-vb-label-gray text-center">
        {"Create Video"}
      </p>
    </div>
  );
};

export default CreateVideoCard;
